module.exports = __webpack_public_path__ + "img/digitastic-tree.6439dde9.jpg";